import { Show } from "../constants/schema.js";
import { bHas } from "./bit.js";
//#region src/utils/memo.ts
var isMemoShown = ({ settings }) => !bHas(settings.show, Show.hideMemo);
//#endregion
export { isMemoShown };
